export const getGasPrice = () => process.env.REACT_APP_GAS_PRICE;

export const gasPrice = getGasPrice();
